import React from 'react';
import NavBar from '../components/navbar';
import Footer from '../components/footer';
import CardStack from '../components/CardStack';
import "../styles/responsive.css"
// import bg from "../images/joyfuel_smiling_face_background.png"
const Home = () => {
  return (
    

<div style={{display:'flex', flexDirection:'column', overflowX: 'hidden'}}>
<NavBar/>


<section  className="bgproperties" style={{ display: 'flex', flexDirection: 'column',flex:'1', justifyContent:'center',  alignItems:'bottom', height:'inherit' }}>
      <div className='intro' style={{marginLeft:"5%",marginRight:"5%"}}>
      <h1 className="intro" style={{color:'white',marginBottom:'0px',justifyContent:'center', fontFamily: 'Poppins', textAlign:'center'}}>Introducing JoyFuel <br/>by Laroye AI:</h1>
      <p className="text" style={{color:'white',marginTop:'0px',fontFamily: 'Poppins',
      marginBottom:'1%'}}><br/>The App that balances social media usage for optimal mental well-being. </p>
      <span className='marginDown'></span>
      </div>
      </section>
<h1 style={hd1}> Embrace a balanced digital<br/>
life with JoyFuel</h1><br/>
<p  className="text" style={hd2}>
It's not just about limiting screen time; it's about optimizing the moments
spent online, leaving you with a lasting sense of happiness and fulfillment.
Guided by the goal of optimizing social media use, JoyFuel focuses on
harnessing the positive aspects of your online interactions. This not only
aids in avoiding digital overload but also turns your social media time into
opportunities for joy, learning, and connection.
</p>
<section id="cards" >
      <CardStack/>
      </section>   
 <Footer/>
</div>


  );
};

const hd1 = {    fontFamily: 'Poppins',
 margin:"2em", color:'#ec6130', textAlign:'center'}


 
const hd2 = {    fontFamily: 'Poppins',
 margin:"-2em 5em 15em 5em", color:'black',
  textAlign:'center', justifyContent:'center',
  align:'center',alignItems:'center'}

const hd3 = {    fontFamily: 'Poppins',flex:'', margin:"0 2% 0 2%", color: 'white'
,position:'center',bottom:'14vh', alignItems:'center'}


export default Home;
